import "./AsianFooter.scss";
import FooterLinks from "./components/FooterLinks/FooterLinks";
import FooterLogos from "./components/FooterLogos/FooterLogos";

const AsianFooter = (props: { className?: string }): React.JSX.Element => {
  const { className } = props;
  return (
    <div className={`footer ${className !== undefined ? className : ""}`}>
      <FooterLinks />
      <FooterLogos
        gamcare={() => {
          window.open("https://www.gamcare.org.uk/", "_blank");
        }}
        gamblingcontrol={() => {
          window.open(
            "https://www.gamblingcontrol.org/licensees/egambling-licensees/",
            "_blank"
          );
        }}
      />
    </div>
  );
};

export default AsianFooter;
